import React, { useState } from "react"
import styled from "styled-components"
import Typography from "@material-ui/core/Typography/Typography"
import CloseIcon from "@material-ui/icons/Close"
import {
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core"
import qrImage from "resources/assets/qr-code.png"
import axios from "axios"
import { HorizontalSpacer, VerticalSpacer } from "components/elements/Spacer"
import { pushToFirebase } from "analytics/manager"
import { events } from "analytics/events"
import { isBrowser } from "react-device-detect"
import Box from "@material-ui/core/Box/Box"
import Button from "@material-ui/core/Button/Button"

const StyledTextField = styled(TextField)`
  fieldset {
    border-radius: 50px;
  }
`

const StyledDiv = styled.div`
  height: auto;
  text-align: center;

  img {
    width: 100px;
    height: 100px;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  h5 {
    font-weight: 700;
  }

  p {
    margin: 0px;
    padding: 0px;
  }

  .phone-number {
  }

  .seperator {
    position: absolute;
    border-radius: 50px;
    left: 50%;
    margin-top: 120px;
    margin-left: 64px;
    padding: 8px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #0000001a;
    border: 1px solid #70707033;
    width: 50px;
    height: 50px;
  }

  .qr {
    background-color: #f8f8f8;
    padding: 48px;
  }

  .phone {
    padding: 48px;
  }

  .closebtn {
    margin: 8px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .disabled {
    background-color: #434343;
  }
`
const DownloadDialog = ({ open, handleClose }: any) => {
  const [mobileNumber, setMobileNumber] = useState(Number)
  const [buttonText, setButtonText] = useState("Get App Link")
  const [loading, setLoading] = useState(false)
  const [messageStatus, setMessageStatus] = useState(false)
  const [isNumberInvalid, setisNumberInvalid] = useState(Boolean)

  const onMobileNumberChange = (event: any) => {
    setMobileNumber(event.target.value.replace(/[^0-9]/g, ""))
  }

  const checkInfo = () => {
    if (mobileNumber.toString().length != 10) setisNumberInvalid(true)
    else {
      setLoading(true)
      sendMessage()
    }
  }

  const closeDialog = () => {
    setMessageStatus(false)
    setButtonText("Get App Link")
    handleClose()
  }

  const sendMessage = async () => {
    const URL = "https://main-service-prod.sixergame.com/global/sendAppURL"

    setisNumberInvalid(false)
    await axios
      .post(URL, {
        mobileNumber: mobileNumber,
      })
      .then(response => {
        if (response.status === 200) {
          setButtonText("App Link Sent")
          setLoading(false)
          setMessageStatus(true)
        }
      })
      .catch(err => {
        setButtonText("Error")
        setLoading(false)
        setMessageStatus(true)
        console.warn(err)
      })
    pushToFirebase(events.web.web_getAppLink)
  }

  return (
    <>
      {isBrowser && (
        <Dialog open={open} maxWidth={"xl"} disableScrollLock={true}>
          <StyledDiv>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start"
            >
              {/* <Grid item xs={6} className="phone">
                <Grid container direction="column">
                  <Typography variant="h5" align="left">
                    Enter your Phone Number to get the official Sixer App link
                    via SMS
                  </Typography>
                  <VerticalSpacer size={30} />

                  <Grid container direction="row" alignContent="center">
                    <Grid item xs>
                      <StyledTextField
                        id="outlined-basic"
                        variant="outlined"
                        helperText={
                          isNumberInvalid ? "Invalid phone number" : ""
                        }
                        onChange={onMobileNumberChange}
                        fullWidth
                        type="tel"
                        disabled={messageStatus}
                        error={isNumberInvalid}
                        placeholder="Mobile Number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography variant="h4">+91</Typography>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <HorizontalSpacer size={20} />
                    <Grid item>
                      <VerticalSpacer size={6} />
                      {!loading && (
                        <Button
                          variant="contained"
                          disableElevation
                          disabled={messageStatus}
                          onClick={checkInfo}
                          style={{
                            backgroundColor: messageStatus
                              ? "#8d8c8c"
                              : "#4dc11a",
                            boxShadow: messageStatus
                              ? "none"
                              : "0px 5px 20px #4dc11a66",
                            color: "#fff",
                            borderRadius: "24px",
                          }}
                        >
                          {buttonText}
                        </Button>
                      )}
                      {loading && (
                        <>
                          <Box ml={9} mr={8} />
                          <CircularProgress
                            size={46}
                            style={{ color: "#4dc11a" }}
                          />
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <div className="seperator">
                <Typography variant="subtitle1">OR</Typography>
              </div> */}

              <Grid item className="qr">
                <img loading="lazy" src={qrImage} alt="qr code" />
                <VerticalSpacer size={20} />
                <Typography variant="subtitle1">
                  <p> Scan the QR Code above to </p> download the official Sixer
                  App
                </Typography>
              </Grid>
              <IconButton onClick={closeDialog} className="closebtn">
                <CloseIcon />
              </IconButton>
            </Grid>
          </StyledDiv>
        </Dialog>
      )}
    </>
  )
}

export default DownloadDialog
